import { IconButton } from '@chakra-ui/react';
import { ChevronDownIcon } from 'ui-components/dist/ChevronDownIcon';
import { ChevronUpIcon } from 'ui-components/dist/ChevronUpIcon';
import { CloseIcon } from 'ui-components/dist/CloseIcon';
import { DropdownIconProps } from '~/components/AutocompleteDropdown/types';

export const DropdownIcon: React.FC<DropdownIconProps> = ({
  isOpen,
  isSelected,
  isDisabled,
  onRemove,
  onOpen,
  onClose,
}) => {
  if (isOpen && isSelected) {
    return (
      <IconButton
        colorScheme="none"
        aria-label="cross-button"
        icon={<CloseIcon color="primary.500" boxSize={6} />}
        height="auto"
        onClick={onRemove}
        isDisabled={isDisabled}
      />
    );
  }
  if (isOpen) {
    return (
      <IconButton
        colorScheme="none"
        aria-label="caret-up-button"
        icon={<ChevronUpIcon color="primary.700" boxSize={6} />}
        height="auto"
        onClick={onClose}
        isDisabled={isDisabled}
      />
    );
  }
  return (
    <IconButton
      colorScheme="none"
      aria-label="caret-down-button"
      icon={<ChevronDownIcon color="primary.300" boxSize={6} />}
      height="auto"
      onClick={onOpen}
      isDisabled={isDisabled}
    />
  );
};
